import { HttpErrorResponse } from '@angular/common/http';

/**
 * Text aus `{ error: "…" }`, so antwortet der `ApiExceptionHandler` bei 400 und 409.
 * Andere Status koennen interne Details tragen und bekommen den Standardtext des Aufrufers.
 */
export function serverMessage(err: unknown): string | null {
  const meant = err instanceof HttpErrorResponse && (err.status === 400 || err.status === 409);
  const body: unknown = meant ? err.error : null;
  const message = body && typeof body === 'object' ? (body as { error?: unknown }).error : null;
  return typeof message === 'string' && message.length > 0 ? message : null;
}

/** 409 mit `code=NAME_TAKEN`: Der Name ist schon vergeben; der Aufrufer zeigt dafuer einen eigenen Text. */
export function isNameTaken(err: unknown): boolean {
  return err instanceof HttpErrorResponse && err.status === 409 && err.error?.code === 'NAME_TAKEN';
}
